import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/reduxHooks";
import ColorsCheck from "../../../../../pages/ProductDetailPage/ColorsCheck";
import { IProduct } from "../../../../interfaces/IProduct";
import { fetchProductColors } from "../../../../store/slices/viewSlice";
import Collections from "../../Collections/Collections";
import Popup from "../../Popup";
import Switcher from "../../Switcher";
import ProductItem from "./ProductItem";
// import ProductImg from "../../assets/productdetailimage.png";
import { useEffect, useState } from "react";
import StyleCheck from "../../../../../pages/ProductDetailPage/StyleCheck";
import VariantColorPicker from "./ColorPicker/VariantColorPicker";
import Infoblock from "../../InfoBlock";
import { nextStep } from "../../../../store/slices/stepSlice";

const chosenProductsMock = [{ id: 1 }, { id: 2 }];

const Products = () => {
  const [chosenProducts, setChosenProducts] = useState(chosenProductsMock);
  const [showCollections, setShowCollections] = useState(false);
  const [colorChosen, setColorChosen] = useState("#000000");
  const [styleChosen, setStyleChosen] = useState(1);
  const [printMethod, setPrintMethod] = useState("DTG");
  const [pageLoading, setPageLoading] = useState(true);

  const dispatch = useAppDispatch();
  const productData: IProduct = useAppSelector(
    (state: any) => state.product.product_data
  );
  const productOption: any = useAppSelector(
    (state: any) => state.product.product_colors.catalogproductvariants
  );

  useEffect(() => {
    dispatch(fetchProductColors({}));
  }, []);

  const handleDeleteProduct = (id: any) => {
    const newChosenProducts = chosenProducts.filter((item) => item.id !== id);
    setChosenProducts(newChosenProducts);
  };

  const groupColorsBasedOnOption1 = (colors: any) => {
    const groupedColors: any = {};
    colors.forEach((color: any) => {
      if (!groupedColors[color.option1]) {
        groupedColors[color.option1] = [];
      }
      groupedColors[color.option1].push(color);
    });

    const resultArray = [];

    for (const color in groupedColors) {
      if (groupedColors.hasOwnProperty(color)) {
        // Pick the first item from each group
        const firstItem = groupedColors[color][0];
        resultArray.push(firstItem);
      }
    }

    return resultArray;
  };

  const renderProductOption = () => {
    if (productOption.length > 0) {
      // debugger;
      // const jsxElements = productOption.map((value: any, index: any) => {
      //   if (typeof value === "object" && value !== null && "Name" in value) {
      //     const optionObject = value as {
      //       Name: string;
      //       optionId: string;
      //       catalogoptionsvalues: any;
      //     };
      //     let colors_data = optionObject.catalogoptionsvalues;
      //     debugger;
      //     const colorsValue: string = colors_data[0]?.value || "";
      //     const option_value: string[] = colorsValue.split(",");

      //     const style_option = option_value.map((item: any, index) => ({
      //       id: index,
      //       img: "",
      //       label: item,
      //       name: optionObject.Name,
      //     }));

      //     // const jsxElementss = optionObject.catalogoptionsvalues.map((color, index) => (
      //     //   <div key={index} color={color}>{color}</div>
      //     // ));
      //     return (
      //       <>
      //         <div key={index}>
      //           {optionObject.Name != "Color" && optionObject.Name !== "Style"
      //             ? optionObject.Name
      //             : ""}
      //         </div>
      //         <div>
      //           {optionObject.Name === "Color" ? (
      //             <div className="my-3">
      //               <ColorsCheck
      //                 colorChosen={colorChosen}
      //                 setColorChosen={setColorChosen}
      //                 colors={option_value}
      //               />
      //             </div>
      //           ) : optionObject.Name === "Style" &&
      //             style_option &&
      //             style_option.length > 0 ? (
      //             <StyleCheck
      //               styleChosen={styleChosen}
      //               setStyleChosen={setStyleChosen}
      //               styles={style_option}
      //             />
      //           ) : optionObject.Name === "Size" &&
      //             style_option &&
      //             style_option.length > 0 ? (
      //             <StyleCheck
      //               styleChosen={styleChosen}
      //               setStyleChosen={setStyleChosen}
      //               styles={style_option}
      //             />
      //           ) : (
      //             ""
      //           )}
      //         </div>
      //       </>
      //     );
      //   } else {
      //     // Handle the case where 'Name' property is not present
      //     return <div key={index}>Invalid object structure</div>;
      //   }
      // });

      return (
        <div>
          {" "}
          <div className="my-3">
            <VariantColorPicker
              colorChosen={colorChosen}
              setColorChosen={setColorChosen}
              colors={groupColorsBasedOnOption1(productOption)}
            />
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <div className="font-bold text-2xl tracking-wide">Select Your Colors</div>
      <div className="text-[#8D9095] border-b border-solid border-lightgrey pb-3 mb-3">
        Select your colors and sizes by clicking on the color picker below.
      </div>
      {/* {productOption ? productOption.map(() => {}) : ""} */}
      {renderProductOption()}
      {/* {chosenProducts.map((item) => (
        <ProductItem
          key={item.id}
          id={item.id}
          productData={productData}
          handleDeleteProduct={handleDeleteProduct}
        />
      ))} */}

      <ProductItem
        productData={productData}
        handleDeleteProduct={handleDeleteProduct}
      />
      {/*  <button
        onClick={() => setShowCollections(true)}
        className="border-2 border-dashed border-primaryred w-full p-3 text-lg text-primaryred font-bold"
      >
        + Add Products
      </button>
      {/* <Switcher /> */}

      <Popup
        show={showCollections}
        setShow={setShowCollections}
        title="All Products"
        maxWidth={"90vw"}
      >
        <Collections />
      </Popup>
      <button
        onClick={() => dispatch(nextStep())}
        className="my-6 rounded-full bg-primaryred text-white text-xl py-4 px-8 uppercase font-bold tracking-wide shadow-lg hover:shadow-xl transition-all transform hover:scale-105 disabled:opacity-60 disabled:hover:scale-100 disabled:hover:shadow-lg flex items-center justify-center mx-auto"
      >
        <div className="uppercase text-sm md:text-base lg:text-base">Next Choose Quantities 👉🏻</div>
      </button>
      <Infoblock type="warning">
        <div className="flex justify-center items-center gap-5">
          <svg
            width="30"
            height="50"
            viewBox="0 0 30 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.5833 14.0292C29.5833 22.7042 21.7708 28.5708 21.7708 35.4167H17.6208C17.6229 31.0854 19.6979 27.4458 21.7208 23.9312C23.6208 20.6292 25.4167 17.5083 25.4167 14.0292C25.4167 7.55417 20.1729 4.16667 14.9917 4.16667C9.81874 4.16667 4.58332 7.55417 4.58332 14.0292C4.58332 17.5083 6.37916 20.6292 8.27916 23.9312C10.3021 27.4458 12.375 31.0854 12.3771 35.4167H8.22916C8.22916 28.5708 0.416656 22.7021 0.416656 14.0292C0.416656 4.98125 7.70416 0 14.9917 0C22.2875 0 29.5833 4.9875 29.5833 14.0292ZM21.25 38.5417C21.25 39.1167 20.7833 39.5833 20.2083 39.5833H9.79166C9.21666 39.5833 8.74999 39.1167 8.74999 38.5417C8.74999 37.9667 9.21666 37.5 9.79166 37.5H20.2083C20.7833 37.5 21.25 37.9667 21.25 38.5417ZM21.25 42.7083C21.25 43.2833 20.7833 43.75 20.2083 43.75H9.79166C9.21666 43.75 8.74999 43.2833 8.74999 42.7083C8.74999 42.1333 9.21666 41.6667 9.79166 41.6667H20.2083C20.7833 41.6667 21.25 42.1333 21.25 42.7083ZM17.7062 49.2896C17.3104 49.7396 16.7375 50 16.1375 50H13.8604C13.2604 50 12.6896 49.7396 12.2937 49.2896L9.27082 45.8333H20.7292L17.7062 49.2896Z"
              fill="black"
            />
          </svg>

          <div>
            <div className="text-sm">
              You will set your quantities for each color once you proceed to
              the next step or click button above
            </div>
          </div>
        </div>
      </Infoblock>
    </>
  );
};

export default Products;
